import { useState } from "react";
import { Send, Loader2, CheckCircle2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Stars } from "@/components/reviews/Stars";

export function ReviewForm() {
  const { t } = useLang();
  const [stars, setStars] = useState(0);
  const [name, setName] = useState("");
  const [text, setText] = useState("");
  const [state, setState] = useState("idle");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!stars) return setErr(t("Tap a star first."));
    setState("busy"); setErr("");
    try { await api.addReview({ stars, name, text }); setState("sent"); }
    catch (e2) { setErr(apiError(e2) || t("Something went wrong. Try again.")); setState("idle"); }
  };

  if (state === "sent") {
    return <div className="card ask-sent" data-testid="review-sent"><CheckCircle2 size={20} />{t("Thanks! Your review shows here once it's approved.")}</div>;
  }
  return (
    <form className="card review-form" onSubmit={submit} data-testid="review-form">
      <div className="card-name">{t("Write a review")}</div>
      <Stars value={stars} onPick={(n) => { setStars(n); setErr(""); }} size={30} testid="review-stars" />
      <input className="text-input" data-testid="review-name" maxLength={40} placeholder={t("Your name or handle (optional)")} value={name} onChange={(e) => setName(e.target.value)} />
      <textarea className="text-input ask-text" data-testid="review-text" required minLength={3} maxLength={500}
        placeholder={t("How does the app work for you?")} value={text} onChange={(e) => setText(e.target.value)} />
      {err && <div className="form-error" data-testid="review-error">{err}</div>}
      <button type="submit" className="primary-btn" data-testid="review-submit" disabled={state === "busy"}>
        {state === "busy" ? <Loader2 size={16} className="spin" /> : <Send size={16} />}{t("Send review")}
      </button>
    </form>
  );
}
